import { useTranslation } from "react-i18next";
import { useTheme } from "@repo/tokens";
import type { QuestionData } from "../../models/GetQuestions";
import { getSubjectiveAnswerBoxColors } from "./subjectiveQuestionDynamicStyles";
import styles from "./SubjectiveQuestionTypeScreen.module.scss";

type Props = {
  questionData: QuestionData;
  selectedValue: string;
  setSelectedValue: (val: string) => void;
  onDone?: () => void;
};

export const SubjectiveQuestionTypeScreen = ({
  questionData,
  selectedValue,
  setSelectedValue,
  onDone,
}: Props) => {
  const { t } = useTranslation("selflearn");
  const { theme } = useTheme();
  const isAttempted = questionData.isAttempted ?? false;
  const { borderColor, backgroundColor } = getSubjectiveAnswerBoxColors(
    theme,
    isAttempted,
  );

  return (
    <div className={styles.root}>
      <div
        className={styles.answerBox}
        style={{ borderColor, backgroundColor }}
      >
        {isAttempted ? (
          <div className={styles.attemptedAnswerText}>{selectedValue}</div>
        ) : (
          <>
            <textarea
              className={styles.textInput}
              value={selectedValue}
              onChange={(e) => setSelectedValue(e.target.value)}
              placeholder={t("reviseQuestions.subjective.placeholder")}
              aria-label={t("reviseQuestions.subjective.answerAria")}
            />
            <div className={styles.inputActionsRow}>
              {selectedValue !== "" ? (
                <button
                  type="button"
                  className={styles.linkAction}
                  onClick={() => setSelectedValue("")}
                >
                  {t("reviseQuestions.subjective.clear")}
                </button>
              ) : (
                <span />
              )}
              {selectedValue !== "" ? (
                <button
                  type="button"
                  className={styles.linkAction}
                  onClick={onDone}
                >
                  {t("reviseQuestions.subjective.done")}
                </button>
              ) : null}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
